import * as React from 'react';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../../media/header-logo.webp';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import PositionDescriptionUi from '../../ui/position-description.ui';
import FounderDescriptionUi from '../../ui/founder-description.ui';
import { PositionDescription } from '../../onboarding/onboarding.service';
import classNames from 'classnames';
import styles from './home.module.css';

type HomeUiProps = {
  isAuthenticated: boolean;
  jobRoleData?: PositionDescription | null;
  jobRoleId?: string;
  isFounderRoute: boolean;
};

const HomeUi = ((props: HomeUiProps) => {
  const {
    isAuthenticated,
    jobRoleData,
    jobRoleId,
    isFounderRoute,
  } = props;

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <div className={styles.app}>
      <header className={styles.header}>
        <div className={styles.menuWrapper}>
          <Link to="/">
            <div className={styles.logoWrapper}>
              <img
                src={logo}
                alt="Foundermatcha Logo"
                className={styles.logo}
              />
            </div>
          </Link>
          <div className={classNames(styles.menuItemWrapper, styles.desktopOnly)}>
            <div className={styles.menuItem}>
              <Link
                to="https://www.foundermatcha.com/"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.link}
              >
                About
              </Link>
            </div>
            <div className={styles.menuItem}>
              <Link
                to="/privacy-policy.html"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.link}
              >
                Privacy Policy
              </Link>
            </div>
          </div>
        </div>

        {/* Desktop menu items */}
        {isAuthenticated ? (
          <div className={classNames(styles.menuItem, styles.desktopOnly)}>
            <Link
              to="/dashboard"
              className={styles.link}
            >
              <AccountCircleIcon fontSize="medium" />
            </Link>
          </div>
        ) : (
          <div className={classNames(styles.menuItem, styles.desktopOnly)}>
            <Link
              to="/login"
              className={styles.link}
            >
              Login
            </Link>
          </div>
        )}

        {/* Mobile burger menu button */}
        <button
          className={styles.burgerButton}
          onClick={toggleMobileMenu}
          aria-label="Toggle mobile menu"
        >
          <div className={classNames(styles.burgerLine, { [styles.burgerLineOpen]: isMobileMenuOpen })}></div>
          <div className={classNames(styles.burgerLine, { [styles.burgerLineOpen]: isMobileMenuOpen })}></div>
          <div className={classNames(styles.burgerLine, { [styles.burgerLineOpen]: isMobileMenuOpen })}></div>
        </button>

        {/* Mobile slide-out menu */}
        <div className={classNames(styles.mobileMenu, { [styles.mobileMenuOpen]: isMobileMenuOpen })}>
          <div className={styles.mobileMenuContent}>
            <div className={styles.mobileMenuItem}>
              <Link
                to="https://www.foundermatcha.com/"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.mobileMenuLink}
                onClick={closeMobileMenu}
              >
                About
              </Link>
            </div>
            <div className={styles.mobileMenuItem}>
              <Link
                to="/terms-and-conditions.html"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.mobileMenuLink}
                onClick={closeMobileMenu}
              >
                Privacy Policy
              </Link>
            </div>
            <div className={styles.mobileMenuItem}>
              {isAuthenticated ? (
                <Link
                  to="/dashboard"
                  className={classNames(styles.mobileMenuLink, styles.mobileMenuButton)}
                  onClick={closeMobileMenu}
                >
                  Go to Account
                </Link>
              ) : (
                <Link
                  to="/login"
                  className={classNames(styles.mobileMenuLink, styles.mobileMenuButton)}
                  onClick={closeMobileMenu}
                >
                  Login
                </Link>
              )}
            </div>
          </div>
        </div>

        {/* Overlay for mobile menu */}
        {isMobileMenuOpen && <div className={styles.mobileMenuOverlay} onClick={closeMobileMenu}></div>}
      </header>
      <div className={styles.contentWrapper}>
        {isFounderRoute ? (
          <FounderDescriptionUi
            applyButton
            isAuthenticated={isAuthenticated}
          />
        ) : (
          <PositionDescriptionUi
            roleData={jobRoleData}
            applyButton
            isAuthenticated={isAuthenticated}
            jobRoleId={jobRoleId}
          />
        )}
      </div>
    </div>
  );
});

export default HomeUi;
